import {createStore} from 'vuex'
import createPersistedState from 'vuex-persistedstate';
import menu from "@/store/menu";
import locale from "@/store/locale";
import token from "@/store/token";
import session from "@/store/session";

export default createStore({
	state: {
		sidebarFoldable: false,
		userInfoFoldable: true,
		progressCnt: 0,
	},
	mutations: {
		toggleSidebarFoldable(state) {
			state.sidebarFoldable = !state.sidebarFoldable;
		},
		toggleUserInfoFoldable(state) {
			state.userInfoFoldable = !state.userInfoFoldable;
		},
		resetJobs(state) {
			state.progressCnt = 0;
		},
		startJobs(state) {
			state.progressCnt++
		},
		async finishJobs(state) {
			await setTimeout(() => {
				if(state.progressCnt > 0)state.progressCnt--;
			}, 300)
		},
	},
	getters: {
		PROGRESS_CNT(state) {
			return state.progressCnt;
		},
		PROGRESS_ON(state) {
			return !(state.progressCnt === 0);
		},
		SIDEBAR_FOLDABLE(state) {
			return state.sidebarFoldable;
		},
		USER_INFO_FOLDABLE(state) {
			return state.userInfoFoldable;
		},
	},
	modules: {
		menu: menu,
		locale: locale,
		token: token,
		session: session,
	},
	plugins: [
		createPersistedState({
			paths: [
				"sidebarFoldable",
				"userInfoFoldable",
				"menu",
				"locale",
				"token",
				"session",
			]
		})
	]
});
